<!--<div class="container" *ngIf="error">
  <mat-card>
    <mat-card-content>
        <div class="message-wrapper">
            {{"errors.ERR_LAUNCH_APP_FROM_DEALER_SITE" | translate}}
        </div>
    </mat-card-content>
  </mat-card>
</div>-->

<router-outlet>
</router-outlet>